"use client";
import { useState } from "react";
import {
  Button,
  Box as MantineBox,
  Text as MantineText,
  Title as MantineTitle,
} from "@mantine/core";
import StaticBanner from "@/components/StaticBanner";
import { setMarketingConsent } from "@/lib/client/user";
import { useUser } from "@clerk/nextjs";

import styles from "./styles.module.scss";

const MarketingConsent = () => {
  const { user } = useUser();
  const [selected, setSelected] = useState(false);

  const handleSubmit = (agree: boolean) => {
    setMarketingConsent(agree, user?.id);
    setSelected(true);
  };

  if (!user || user?.publicMetadata?.marketingConsent !== undefined || selected) {
    return null;
  }

  return (
    <StaticBanner>
      <MantineBox className={styles.marketingConsent}>
        <MantineTitle order={1}>Stay in the Loop</MantineTitle>
        <MantineText>
          Sign up for our newsletter and be the first to hear about exciting updates and news from
          our team. No spam, just the good stuff!
        </MantineText>
        <MantineBox className={styles.buttonContainer}>
          <Button onClick={() => handleSubmit(true)} variant="ghost">
            Yes Please!
          </Button>
          <Button onClick={() => handleSubmit(false)} variant="ghost">
            No Thanks
          </Button>
        </MantineBox>
      </MantineBox>
    </StaticBanner>
  );
};

export default MarketingConsent;
